'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Keys that should map from one to another specific locale
var languageMappings = {
  noNO: 'no-no',
  'zh-tw': 'zh-hk'
};

// Locales for which we should map to if the base language is the same
var languageBaseRewrites = {
  pt: 'pt-br',
  no: 'no-no'
};

var timezoneAlreadySetup = false;

function setupTimezone(timezone) {
  if (_I18n2.default.manualTimezone) {
    return;
  }
  if (timezoneAlreadySetup === true) {
    return;
  }

  var timezoneId = timezone.id;

  try {
    if (timezone['moment-data']) {
      timezoneAlreadySetup = true;
      if (!_I18n2.default.moment.tz.zone(timezoneId)) {
        _I18n2.default.moment.tz.add(timezoneId + '|' + timezone['moment-data']);
      }
      return _I18n2.default.changeTimezone(timezoneId);
    } else {
      return Raven && Raven.captureMessage('I18n failed to parse api-verify data: ' + JSON.stringify(portal && portal.timezone));
    }
  } catch (e) {
    console.error('Unable to set up timezone', e);
    return Raven && Raven.captureException(e);
  }
}

function getValidLocale(locale) {
  var validLocale = _I18n2.default.manualLocale || locale || _I18n2.default.locale || 'en';
  var fallbackLookup = languageMappings[validLocale] || languageBaseRewrites[validLocale.substring(0, 2)];
  if (fallbackLookup) {
    validLocale = fallbackLookup;
  }

  return validLocale || _I18n2.default.locale;
}

function setManualOverwrites() {
  _I18n2.default.manualLocale = window.I18N_MANUAL_LANG;
  _I18n2.default.manualTimezone = window.I18N_TZ;
  try {
    var localeOverwrite = localStorage && localStorage.I18N_MANUAL_LANG;
    var timezoneOverwrite = localStorage && localStorage.I18N_TZ;
    _I18n2.default.manualLocale = localeOverwrite;
    _I18n2.default.manualTimezone = timezoneOverwrite;
  } catch (e) {
    _I18n2.default.debugLog('Failed access localStorage ' + e);
  }
}

function loadI18n() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      langEnabled = _ref.langEnabled,
      locale = _ref.locale,
      timezone = _ref.timezone;

  // Ideally we'd get rid of these, but maintain for now
  // Must set overwrites on I18n first
  setManualOverwrites();

  _I18n2.default.debugLog('I18n initiated with: locale = ' + locale + '  timezone = ' + timezone + '  langEnabled = ' + langEnabled);

  var validLocale = getValidLocale(locale);

  if (timezone && timezone.id) {
    setupTimezone(timezone);

    // Set timezone fallbacks
    _I18n2.default.timezone = _I18n2.default.manualTimezone || window.I18N_RENDERED_TZ || _I18n2.default.timezone;
  } else {
    // If we don't have portal data, then we can't use portalTz and even setting a timezone will cause issues
    // If no timezone data, then we should fall back to userTz
    // Without a timezone setting, portalTz returns undefined. So make portalTz work as userTz
    _I18n2.default.moment.portalTz = _I18n2.default.moment.userTz;
    // Fall back on some timezone to not break I18n.moment.fn.portalTz
    // TO DO - modify I18n.moment.fn.portalTz so that it doesn't break without I18n.timezone
    _I18n2.default.timezone = 'US/Eastern';
  }

  _I18n2.default.debugLog('initially setting timezone to ' + _I18n2.default.timezone);

  _I18n2.default.langEnabled = !!_I18n2.default.manualLocale || langEnabled;
  _I18n2.default.debugLog('Lang enabled: ' + langEnabled);

  // Used in I18n.loadLocale
  _I18n2.default.loadedProjects = function () {
    return Object.keys(_I18n2.default.translationsLoaded);
  };

  _I18n2.default.debugLog(validLocale + ' is available locale, changing...');
  return new Promise(function (resolve) {
    // Note: We have to convert to native promise to support chaining
    _I18n2.default.changeLocale(validLocale).then(function () {
      _I18n2.default.fired.ready = true;
      if (window.hubspot && window.hubspot.baldric && window.hubspot.baldric.localeImport) {
        window.hubspot.baldric.localeImport();
      }
      resolve();
    });
  });
}

exports.default = loadI18n;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.327/js/load.js
// module id = 622
// module chunks = 2 3